import { PureComponent, ReactNode } from 'react';

import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

import * as styles from './generic-message.style';

type GenericMessageProps = {
  iconType?: 'connectivity' | 'confirmation' | 'info' | 'warning' | 'error';
  title: ReactNode;
  children?: ReactNode;
  messageType?: string;
  className?: string;
};

// @ts-ignore TODO: fix noImplicitAny error here
const iconMap = key => {
  const icons: object = {
    connectivity: (
      <StatusErrorIcon
        spacing="spacious"
        color={token('color.icon.information')}
        label=""
      />
    ),
    confirmation: (
      <CheckCircleIcon
        spacing="spacious"
        color={token('color.icon.success')}
        label=""
      />
    ),
    info: (
      <StatusInformationIcon
        spacing="spacious"
        color={token('color.icon.discovery')}
        label=""
      />
    ),
    warning: (
      <StatusWarningIcon
        spacing="spacious"
        color={token('color.icon.warning')}
        label=""
      />
    ),
    error: (
      <StatusErrorIcon
        spacing="spacious"
        color={token('color.icon.danger')}
        label=""
      />
    ),
  };
  // @ts-ignore TODO: fix noImplicitAny error here
  return icons[key] || null;
};

// eslint-disable-next-line import/no-default-export
export default class GenericMessage extends PureComponent<GenericMessageProps> {
  render() {
    const { iconType, title, messageType, className } = this.props;

    return (
      <styles.GenericMessageWrapper
        messageType={messageType}
        className={className}
      >
        <styles.GenericMessageHeader>
          {iconMap(iconType)}
          <styles.GenericMessageTitle>{title}</styles.GenericMessageTitle>
        </styles.GenericMessageHeader>
        {this.props.children}
      </styles.GenericMessageWrapper>
    );
  }
}
